import { NUMBER_REGEXP } from '../../constant/constants'

export default (value) => {
  return value && NUMBER_REGEXP.test(value)
}
